import { ApiWorkflowDialog, DialogMessageBox } from '@verantos-dev/shared-components';

import { useCohortExitModal } from './useCohortExitModal';

const CohortExitModal = () => {
  const { title, confirmTitle, content, dialogMessages, onContinueEditing, onExit } =
    useCohortExitModal();

  return (
    <ApiWorkflowDialog
      id="cohortBuildExitDialog"
      title={title}
      onClose={onExit}
      onCloseIconClick={onContinueEditing}
      onSubmit={onContinueEditing}
      dialogMessages={dialogMessages}
    >
      <DialogMessageBox
        id="cohort-exit-message-box"
        title={confirmTitle}
        type="info"
        renderSubmitted={content}
      />
    </ApiWorkflowDialog>
  );
};

export default CohortExitModal;
